import Api from "./api.jsx";
import auth from "../../auth/service";
import * as Constants from "../../../consts/Constants.js";

const DEVELOPER_ROLE = 2;

class VehiclesService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(DEVELOPER_ROLE);
	}

}

export default new VehiclesService(Constants.BASE_URL_SERVER + "eboards/vehicles");